module.exports = __webpack_public_path__ + "7a0e5668402ba1816e0d0cdb80c47d7a.pdf";